<template>
  <nav class="navbar">
    <div class="nav-left">
      <div class="logo">
        <img src="../assets/images/logo.png" height="60px" alt="">
      </div>
    </div>
    
    <div class="nav-center">
      <div class="search-box">
        <input 
          type="text" 
          placeholder="Search games..." 
          v-model="searchQuery"
          @keyup.enter="handleSearch"
        >
        <button @click="handleSearch">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
    
    <div class="nav-right">
      <button class="disclaimer-btn" @click="showDisclaimer = true">
        <i class="fas fa-shield-alt"></i> Disclaimer
      </button>
      <div class="notification">
        <i class="fas fa-bell"></i>
        <span class="badge" v-if="unreadCount">{{ unreadCount }}</span>
      </div>
      <template v-if="userStore.isLoggedIn">
        <button class="config-btn" @click="router.push('/config')">
          <i class="fas fa-cog"></i> Config
        </button>
        <button class="logout-btn" @click="handleLogout">Logout</button>
      </template>
      <button v-else class="login-btn" @click="router.push('/login')">Login</button>
    </div>
  </nav>

  <!-- Disclaimer Modal -->
  <DisclaimerModal :show="showDisclaimer" @close="showDisclaimer = false" />
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '../stores/userStore'
import DisclaimerModal from './DisclaimerModal.vue'

const router = useRouter()
const userStore = useUserStore()
const searchQuery = ref('')
const unreadCount = ref(3)
const showDisclaimer = ref(false)

const handleSearch = () => {
  console.log('Search:', searchQuery.value)
}

const handleLogout = () => {
  userStore.clearUser()
  router.push('/login')
}
</script>

<style scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.nav-left .logo h1 {
  color: #fff;
  font-size: 24px;
  margin: 0;
  background: linear-gradient(45deg, #00b4db, #0083b0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}

.nav-center {
  flex: 1;
  max-width: 500px;
  margin: 0 20px;
}

.search-box {
  display: flex;
  align-items: center;
  background: rgba(255,255,255,0.1);
  border-radius: 25px;
  padding: 5px 15px;
  transition: all 0.3s ease;
}

.search-box:focus-within {
  background: rgba(255,255,255,0.2);
  box-shadow: 0 0 10px rgba(0,0,0,0.2);
}

.search-box input {
  flex: 1;
  background: none;
  border: none;
  color: white;
  padding: 8px;
  outline: none;
}

.search-box button {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.notification {
  position: relative;
  color: white;
  cursor: pointer;
}

.badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4444;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
}

.login-btn, .config-btn, .logout-btn, .disclaimer-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
}

.login-btn {
  background: #1E90FF;
}

.config-btn {
  background: #9370DB;
}

.disclaimer-btn {
  background: #20B2AA;
}

.logout-btn {
  background: #ff4444;
}

.login-btn:hover, .config-btn:hover, .logout-btn:hover, .disclaimer-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
</style> 